(() => {
  function positionProductReviews() {
    const main = document.getElementById('main');
    if (!main) return;
    const move = () => {
      const faq = main.querySelector('.ip-faq, .ak-faq, [data-product-faq]');
      const reviews = main.querySelector('#auto-bk-review-section');
      if (faq && reviews && !reviews.contains(faq) && faq.previousElementSibling !== reviews) {
        faq.before(reviews);
      }
    };
    move();
    // BK Reviews can insert or replace its widget after the page has loaded.
    new MutationObserver(move).observe(main, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionProductReviews, {once: true});
  } else {
    positionProductReviews();
  }
})();
